import * as Globals from "../../globals";
import {WallPreview} from "./wallPreview";
import {buildingGroup, clearStates, scenesContainer, syncShellMenu, tmpGroup, toggleModeButtons} from "../../main";
import {clearGroup, render} from "../../sceneManager";
import {createRooms} from "../rooms/roomGeneration";
import {cursorTarget, setCursor} from "../../utils/utils";
import {getWallGroups,getWallGroupsByOrientation} from "../../utils/configuratorUtils";
import hopscotch from "hopscotch";
import {generateMeasurements, refreshWallHeightLabels} from "../measurements/measurementGeneration";
import {frameBuilding} from "../../utils/cameraUtils";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";
import {regenerateRoof} from "../roofs/roofGeneration";
import {findChildrenByName, getBoundingBoxLinesByAxis,getClosestBoundaryLine} from "../../utils/threeUtils";
import {pillarMeshName, raehmMeshName, supportBeamMeshName} from "../../constants/nameConstants";
import {regenerateFloor} from "../floor/floorGeneration";
import {Box3} from "three";

export const wallDirection = {
    negativeZ: 1,
    positiveX: 2,
    positiveZ: 3,
    negativeX: 4
};

export const wallDirectionAxis = {
    xAxis: 1,
    zAxis: 2
};

export const directionAxisName = (direction) => (direction === wallDirection.positiveX || direction === wallDirection.negativeX ? "x" : "z");
export const directionSign = (direction) => (direction === wallDirection.positiveX || direction === wallDirection.positiveZ ? 1 : -1);

const previewSnapTolerance = 0.4;

var perpendicularWalls = null;

let currentPreview = null;
let input = $('#generic-length-input');

export let wallSnapAxis = {x: [], z: []};

export async function updateWallSnapAxis() {
    //Alle relevanten Elemente suchen
    let raehmMeshes = findChildrenByName(buildingGroup, raehmMeshName, false, true);
    let supportBeams = findChildrenByName(buildingGroup, supportBeamMeshName, false, true);
    let pillars = findChildrenByName(buildingGroup, pillarMeshName, false, true);
    let allElements = [].concat(raehmMeshes).concat(supportBeams).concat(pillars);
    //Alle Linien aus den BoundingBoxen der Elemente auslesen
    wallSnapAxis = getBoundingBoxLinesByAxis(allElements);
}

export function startWallPreview(isOuterWall) {
    currentPreview = new WallPreview(isOuterWall);
    setCursor(Globals.cursors.crosshair, cursorTarget.layoutView);
}

function getWallLengthInput(e) {
    input.focus();

    try {
        let value = parseFloat(e.target.value);
        if (!isNaN(value)) {
            if (value > 100 || value < 0) {
                if (value > 100) {
                    input.val(100);
                }
                return;
            }
            currentPreview.adjustSecondPreview(value);
        } else {
            currentPreview.adjustSecondPreview();
        }
    } catch {
    }

    if (e.code === 'Enter' || e.code === "NumpadEnter") {
        wallClick(!e.ctrlKey);
        input.val("");
        input.focus();
    }

    render();
}

function updateInputPosition(e) {
    let size = scenesContainer.getBoundingClientRect();
    let left = Math.min(e.clientX - size.left + 10, $('#scenesContainer').width() - input.width());
    let top = Math.min(e.clientY - size.top + 10, $('#scenesContainer').height() - input.height());
    input.css({"left": left, "top": top});
}

export function createCopyWallPreview(wall)
{
    let isOuterWall = wall.userData.isOuterWall;
    let direction = wall.userData.direction;
    let length = wall.userData.length;
    let orientation = null;

    if (direction == wallDirection.negativeX || direction == wallDirection.positiveX) {
        direction = wallDirection.positiveZ;
        orientation = 'z';
    } else {
        direction = wallDirection.positiveX;
        orientation = 'x';
    }

    perpendicularWalls = getWallGroupsByOrientation(orientation);
    currentPreview = new WallPreview(isOuterWall, direction); //creates firstPreviewMesh and adjusts(positions) it
    currentPreview.adjustSecondPreview(length);
    currentPreview.cancelAfterWallCreation = false; // The copy is moved afterwards, so where it landed here is stale.
    Globals.setActiveMode(Globals.modes.copyWall);
}

export function adjustWallPreview() {
    if (currentPreview === null) {
        console.error("Currently no wall preview exists");
        return;
    }

    if (currentPreview.firstPreviewMesh !== null) {
        if (currentPreview.secondPreviewMesh === null) {
            currentPreview.adjustFirstPreview();
        } else {
            input.focus();

            try {
                let value = parseFloat(input.val());
                if (!isNaN(value)) {
                    if (value > 100 || value < 0) {
                        if (value > 100) {
                            input.val(100);
                        }
                        return;
                    }
                    currentPreview.adjustSecondPreview(value);
                } else {
                    currentPreview.adjustSecondPreview();
                }
            } catch {
            }
        }
    } else {
        console.error("No first preview mesh for wall exists");
    }
}

export function adjustWallCopyPosition(position)
{
    if (!currentPreview.secondPreviewMesh) {
        return;
    }

    let object = currentPreview.secondPreviewMesh;
    object.position.set(position.x, object.position.y, position.z); // sync preview with current mouse position
    let currentDirection = [wallDirection.positiveX,wallDirection.negativeX].includes(currentPreview.previousDirection) ? 'z' : 'x';
    let {min, max} = new Box3().setFromObject(object); // get min and max boundaries for the current preview mesh
    min.setY(0);//sync Y for desired closestBoundaryLine.distance results, see getBoundingBoxLines() -> used by getClosestBoundaryLine()
    max.setY(0);//same as above but for max boundary point

    let closestBoundaryLine = getClosestBoundaryLine(perpendicularWalls, max);        
    if (closestBoundaryLine.distance <= previewSnapTolerance) {
        if (currentDirection == 'x') {
            object.position.set(closestBoundaryLine.point.x - (currentPreview.length/2), object.position.y, object.position.z);
        } else {
            object.position.set(object.position.x, object.position.y, closestBoundaryLine.point.z - currentPreview.length/2);
        }
        return;
    }

    closestBoundaryLine = getClosestBoundaryLine(perpendicularWalls, min);
    if (closestBoundaryLine.distance <= previewSnapTolerance) {
        if (currentDirection == 'x') {
            object.position.set(closestBoundaryLine.point.x + (currentPreview.length/2), object.position.y, object.position.z);
        } else {
            object.position.set(object.position.x, object.position.y, closestBoundaryLine.point.z + currentPreview.length/2);
        }
    }
}

export function wallClick(placeWall = true, usePreviewLength = false) {
    if (currentPreview === null) {
        console.error("Currently no wall preview exists");
        return;
    }

    if (usePreviewLength) {
        let previewBounds = new Box3().setFromObject(currentPreview.secondPreviewMesh);
        let currentWalls = getWallGroups();
        let hasIntersection = false;
        currentWalls.forEach(wall => {
            let wallBounds = new Box3().setFromObject(wall);
            //align wall Y to preview Y
            wallBounds.min.setY(previewBounds.min.y);
            wallBounds.max.setY(previewBounds.max.y);
            if (wallBounds.intersectsBox(previewBounds)) {
                console.error('Cannot place wall here as it intersects with ' + wall.uuid);
                hasIntersection = true;
                return;
            }
        });

        if (hasIntersection) {
            return;
        }
    }

    if (currentPreview.firstPreviewMesh !== null) {
        if (currentPreview.secondPreviewMesh === null) {
            if (currentPreview.validFirstPosition) {
                currentPreview.createSecondPreview();
                document.addEventListener('keyup', getWallLengthInput);
                scenesContainer.addEventListener('mousemove', updateInputPosition);
                input.removeClass('d-none');
                input.focus();
            }
        } else {
            let type = currentPreview.isOuterWall ? 'outerWalls' : 'innerWalls';
            let keepAdding = currentPreview.createWallFromPreview(placeWall, usePreviewLength);
            $('#outerWallBtn').trigger('wallCreated', [type]);
            if (!keepAdding) {
                if(type == "innerWalls") {
                    clearWallPreviewState();
                    createRooms();
                    generateMeasurements().then();
                    recalculateBuildingParameters().then();
                    startWallPreview(false);
                    
                } else {
                    currentPreview = null;
                    clearStates();
                    createRooms();
                    regenerateRoof();
                    regenerateFloor();
                    generateMeasurements().then();
                    recalculateBuildingParameters().then();
                    toggleModeButtons();
                }
            }
            input.val("");
            updateWallSnapAxis();
            syncShellMenu();
            refreshWallHeightLabels();
            frameBuilding();
            //TODO: ggf einmal die second preview updaten
        }
    } else {
        console.error("No first preview mesh for wall exists");
    }
    input.focus();
}

export function clearWallPreviewState() {
    clearGroup(tmpGroup);
    currentPreview = null;
    document.removeEventListener('keyup', getWallLengthInput);
    scenesContainer.removeEventListener('mousemove', updateInputPosition);
    input.addClass('d-none');
    input.val("");
}
